module.exports = __webpack_public_path__ + "img/prize-02.45b79adf.png";